<template>
  <div class="image-ad-container">
    <div
      v-if="type === '1' || type === '4'"
      :style="{ marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <el-carousel trigger="click" :height="imgHeight + 'px'">
        <el-carousel-item
          v-for="(v, i) in imgList"
          :key="i"
          @click="toUrl(v.url)"
        >
          <div class="img-ad-wrapper">
            <img
              class="img"
              :src="v.src"
              ref="image"
              alt="图片广告"
              @load="imageLoad"
              :class="{ radius: borderRadius }"
            />
            <span class="text" v-show="v.text">{{ v.text }}</span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <ul class="img-list" v-if="type === '2'">
      <li
        class="list-item"
        v-for="(v, i) in imgList"
        :key="i"
        @click="toUrl(v.url)"
        :style="{
          marginLeft: margin + 'px',
          marginRight: margin + 'px',
          marginBottom: marginBottom + 'px'
        }"
      >
        <img
          class="img"
          :src="v.src"
          alt="图片广告"
          :class="{ radius: borderRadius }"
        />
        <span v-show="v.text" class="text">{{ v.text }}</span>
      </li>
    </ul>
    <div
      v-if="type === '3'"
      class="flex flex-between"
      :style="{ marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <div class="flex-1" v-if="leftImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight + 'px'"
          :interval="4000"
        >
          <el-carousel-item
            v-for="(v, i) in leftImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad"
                ref="image"
                :src="v.src"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="flex-1" v-if="rightImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight + 'px'"
          class="flex-1"
          :interval="5000"
        >
          <el-carousel-item
            v-for="(v, i) in rightImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad"
                :src="v.src"
                ref="image"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>      
    </div>
    <div
      v-if="type === '5'"
      class="flex flex-between"
      :style="{ marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <div class="flex-1" v-if="leftImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight2 + 'px'"
          :interval="4000"
        >
          <el-carousel-item
            v-for="(v, i) in leftImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad2"
                ref="image2"
                :src="v.src"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="flex-1 flex flex-column">
      <div class="flex-1" v-if="rightImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight3 + 'px'"
          class="flex-1"
          :interval="5000"
        >
          <el-carousel-item
            v-for="(v, i) in rightImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad3"
                :src="v.src"
                ref="image3"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>   
      <div class="flex-1" v-if="rightImgList2.length">
        <el-carousel
          trigger="click"
          :height="imgHeight3 + 'px'"
          class="flex-1"
          :interval="5000"
        >
          <el-carousel-item
            v-for="(v, i) in rightImgList2"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad3"
                :src="v.src"
                ref="image3"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>    
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    isSwiper: {
      type: Boolean,
      default: false
    },
    leftImgList: {
      type: Array,
      default: () => {}
    },
    rightImgList: {
      type: Array,
      default: () => {}
    },
    rightImgList2: {
      type: Array,
      default: () => {}
    },
    imgList: {
      type: Array,
      default: () => {}
    },
    borderRadius: {
      type: Boolean,
      default: false
    },
    margin: {
      type: Number,
      default: 0
    },
    marginBottom: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      imgHeight: 0,
      imgHeight2: 0,
      imgHeight3: 0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    imageLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.image[0].height;
        console.log("this.imgHeight:",this.imgHeight);
      });
    },
    imageLoad2() {
      this.$nextTick(() => {
        this.imgHeight2 = this.$refs.image2[0].height;
        console.log("this.imgHeight2:",this.imgHeight2);
      });
    },
    imageLoad3() {
      this.$nextTick(() => {
        this.imgHeight3 = this.$refs.image3[0].height;
        console.log("this.imgHeight2:",this.imgHeight2);
      });
    },
    toUrl() {}
  }
};
</script>
<style lang="scss" scoped>
.image-ad-container {
  .img-ad-wrapper {
    position: relative;
  }

  .img {
    width: 100%;
    font-size: 0;
  }
  .text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(51, 51, 51, 0.8);
    color: #fff;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }

  .img-list {
    .list-item {
      position: relative;
      font-size: 0;
    }

    .radius {
      border-radius: 10px;
    }
  }
}
</style>
